import { useEffect, useState } from 'react'
import {
  getWebsiteCatalogFallback,
  subscribeToVisibleCatalogProducts,
  type CatalogProduct,
} from './firebase'

/**
 * Live public catalog controls. Static catalog content and any device-local
 * admin saves remain available when Firestore catalog access is unavailable.
 */
export function useCatalogProducts(): CatalogProduct[] {
  const [products, setProducts] = useState<CatalogProduct[]>([])

  useEffect(() => {
    const fallback = getWebsiteCatalogFallback()
    return subscribeToVisibleCatalogProducts(setProducts, () => setProducts(fallback))
  }, [])

  return products
}
